<template>
  <div class="signature">
      <div v-html="details"></div>
  </div>
</template>
<script>
export default {
  data(){
      return {
          details:sessionStorage.getItem("signature")
      }
  }
}
</script>
<style lang="less" scoped>
.signature{
    padding:50px 30px;
}
</style>

